// 图像生成相关翻译

export const generation = {
    // 提示词和生成相关
    enterPrompt: '輸入您的提示詞',
    promptPlaceholder: '例如：山巒上美麗的日落，油畫風格，暖色調，詳細的風景畫...',
    generationCount: '生成數量',
    images: '張圖片',
    credits: '積分',
    tip: '提示：描述越詳細，生成的圖像越接近您的想像',
    generating: '生成中...',
    startGeneration: '開始生成',
    generatedImage: '生成的圖像',
    generateSuccess: '生成成功',
    download: '下載',
    downloadError: '下載失敗，請稍後重試',
    downloadImageError: '下載失敗，請稍後重試',
    
    // 错误处理
    unknownError: '發生未知錯誤',
    contentPolicyError: '檢測到內容政策違規',
    contentPolicySuggestion: '請修改您的提示詞以符合內容準則',
    rateLimitMessage: '超出速率限制',
    rateLimitSuggestion: '請稍等片刻再試',
    creditsMessage: '積分不足',
    creditsSuggestion: '請購買更多積分以繼續',
    generalSuggestion: '請稍後重試',
    enterPromptError: '請輸入提示詞',
    generateImageError: '生成圖像失敗',
    rateLimitError: '超出速率限制，請稍後重試',
    insufficientCreditsError: '積分不足',
    networkError: '網絡錯誤，請檢查您的連接',
    
    // 灵感和标签
    inspiration: '靈感',
    inspirationDescription: '從熱門主題和風格中獲得靈感',
    tags: {
      landscape: '風景',
      portrait: '肖像',
      architecture: '建築',
      art: '藝術',
      scifi: '科幻',
      nature: '自然',
      animals: '動物',
      creative: '創意'
    },
    
    // AI图像生成
    aiImageGeneration: 'AI圖像生成',
    style: '風格',
    aspectRatio: '圖像比例',
    styles: {
      realistic: '真實',
      artistic: '藝術',
      anime: '動漫',
      cartoon: '卡通',
      abstract: '抽象'
    },
    styleDescriptions: {
      realistic: '照片級真實圖像',
      artistic: '創意藝術風格',
      anime: '日式動漫風格',
      cartoon: '卡通插畫風格',
      abstract: '抽象概念藝術'
    },
    sizeDescriptions: {
      squareSmall: '正方形小',
      squareLarge: '正方形大 (1:1)',
      landscape: '橫向',
      portrait: '縱向',
      portrait23: '縱向 (2:3)',
      landscape32: '橫向 (3:2)',
      portrait34: '縱向 (3:4)',
      landscape43: '橫向 (4:3)',
      portrait45: '縱向 (4:5)',
      landscape54: '橫向 (5:4)',
      portrait916: '縱向 (9:16)',
      landscape169: '橫向 (16:9)',
      ultrawide219: '超寬屏 (21:9)'
    },
    
    // 標籤提示文本
    tagPrompts: {
      landscape: '日落時分，雄偉的山脈倒映在晶瑩剔透的高山湖泊中，金色的陽光穿透戲劇性的雲層，照片級真實感',
      portrait: '一張富有電影感的年輕女性肖像，臉上有雀斑，頭髮隨風飄動，自然光線，背景虛化，35mm鏡頭拍攝，細節豐富',
      architecture: '充滿未來感的對持續發展城市天際線，擁有垂直花園和玻璃摩天大樓，溫暖的陽光，鳥瞰圖，建築效果圖',
      art: '一幅超現實主義油畫，描繪沙漠中掛在樹枝上融化的時鐘，薩爾瓦多·達利風格，夢幻般的氛圍，色彩鮮豔',
      scifi: '雨夜中的賽博朋克街道場景，霓虹燈閃爍的城市，飛行汽車，全息圖，濕潤的路面反射，銀翼殺手風格',
      nature: '一片神秘的古老森林，發光的蘑菇和螢火蟲，長滿苔蘚的岩石，小溪，魔法氛圍，奇幻藝術風格',
      animals: '一隻彩色樹蛙在濕潤葉子上的微距特寫，水珠，焦點清晰，充滿活力的綠色和橙色',
      creative: '雙重曝光圖像，將人物剪影與星空和森林景觀結合，空靈且充滿藝術感'
    }
  };
